var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"retrieveLoginId",attrs:{"data-qa":"confirmexit-div-qz21yr"}},[_c('Modal',{attrs:{"config":_vm.modalConfig}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }